import React, { useRef, useEffect, useState } from "react";
import "./scrollReveal.css";

const ScrollReveal = ({ children }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const sectionNode = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionNode) {
      observer.observe(sectionNode);
    }

    return () => {
      if (sectionNode) {
        observer.unobserve(sectionNode);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`scroll-reveal ${isVisible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
